import { watchFetchPurchaseOrders } from './list'
import { watchRequestPurchaseOrdersAccess } from './requestAccess'

export const purchaseOrderSagas = [watchFetchPurchaseOrders, watchRequestPurchaseOrdersAccess]
